(function () {
  var STORAGE_KEY = 'dm_welcome_offer_seen_v1';
  var DELAY_MS = 1800;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var root = document.querySelector('[data-dm-welcome]');
    if (!root) return;

    var dialog = root.querySelector('.dm-welcome__dialog');
    var closes = root.querySelectorAll('[data-dm-welcome-close]');
    var form = root.querySelector('#DmWelcomeOfferForm');
    var successNode = root.querySelector('[data-dm-welcome-success]');
    var lastFocus = null;

    function hasSeen() {
      try {
        return window.localStorage.getItem(STORAGE_KEY) === '1';
      } catch (e) {
        return false;
      }
    }

    function markSeen() {
      try {
        window.localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {}
    }

    function open(force) {
      if (!force && hasSeen()) return;
      lastFocus = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dm-welcome-open');
      var focusTarget = root.querySelector('.dm-welcome__input') || root.querySelector('.dm-welcome__close');
      if (focusTarget) focusTarget.focus();
    }

    function close() {
      markSeen();
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dm-welcome-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    closes.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });

    if (form) {
      form.addEventListener('submit', function () {
        markSeen();
      });
    }

    // After successful Shopify signup redirect, show confirmation once
    if (successNode) {
      open(true);
      return;
    }

    if (hasSeen()) return;

    window.setTimeout(function () {
      open(false);
    }, DELAY_MS);
  });
})();
